import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';
import hotelLogo from '../../assets/Navbar/Bougainvilla.png'; // Update this path based on your directory structure

function AdminLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        // POST request to your PHP backend for login
        const response = await fetch('http://localhost/hotel-bougainvilla/hotel-admin/backend/login.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        });

        const data = await response.json();
        if (data.success) {
            navigate('/admin/dashboard'); // Assuming a dashboard route
        } else {
            alert('Login failed!');
        }
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-left">
                <img src={hotelLogo} alt="Hotel Logo" />
                <h2>HOTEL BOUGAINVILLA</h2>
            </div>
            <div className="admin-login-right">
                <div className="admin-login-box">
                    <h1 className="admin-login-title">ADMIN LOGIN</h1>
                    <form className="admin-login-form" onSubmit={handleLogin}>
                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="admin-login-input"
                            required
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="admin-login-input"
                            required
                        />
                        <p className="forgot-password">Forgot Password?</p>
                        <button type="submit" className="admin-login-button">Login</button>
                    </form>
                    <div className="admin-login-link">
                        <p>Don't have an account? <a href="/admin/register">Register here</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;
